import React from 'react';
import Button from '../base/Button';
import { trackButtonClick } from '../../utils/analytics';
import './Hero.css';

function Hero() {
  const scrollToSignup = () => {
    trackButtonClick('Take back control', 'hero');
    const signupSection = document.getElementById('signup');
    if (signupSection) {
      signupSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToFeatures = () => {
    trackButtonClick('Learn about Within', 'hero');
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleScrollIndicatorClick = () => {
    trackButtonClick('Scroll indicator', 'hero');
    scrollToFeatures();
  };

  return (
    <section className="hero">
      {/* Curved background shape */}
      <div className="hero-background">
        <svg 
          className="hero-background-svg" 
          viewBox="0 0 1440 700" 
          fill="none" 
          preserveAspectRatio="none"
        >
          <path 
            d="M0 0H1440V550C1440 550 1200 650 720 650C240 650 0 550 0 550V0Z" 
          />
        </svg>
      </div>

      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title large-title animate-fade-up">
            Study and work sustainably
            <br />
            <span className="hero-title-accent">within</span> an unsustainable system
          </h1>
          <p className="hero-subtitle body-text animate-fade-up-delay-1">
            Minimize mental and physical stress in a world of constant notifications, 
            performance pressure, and endless sitting.
          </p>
          
          <div className="hero-cta animate-fade-up-delay-2">
            <Button 
              variant="primary" 
              onClick={scrollToSignup}
            >
              Take back control
            </Button>
            <Button 
              variant="outline" 
              onClick={scrollToFeatures}
            >
              Learn about Within
            </Button>
          </div>
        </div>
      </div>
      
      {/* Scroll down indicator - positioned at bottom center of viewport */}
      <button 
        className="hero-scroll-indicator animate-fade-up-delay-3"
        onClick={handleScrollIndicatorClick}
        aria-label="Scroll to features"
      >
        <svg 
          width="28" 
          height="28" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="hero-scroll-arrow"
        >
          <path 
            d="M6 9L12 15L18 9" 
            stroke="currentColor" 
            strokeWidth="2.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            strokeOpacity="0.8"
          />
        </svg>
      </button>
    </section>
  );
}

export default Hero;

